import { CollideEvent, CollideId } from '../../defs/collide';
import {
  WallBlockEntity,
  despawnBlockEntity,
} from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { CollideHandler, ICollision } from './ICollision';

/*
  Wall block collision resolver
*/
export class WallCollision implements ICollision {
  // fields
  //-------------------------------------------------------------------------
  // input
  private readonly _scene: GameScene;
  private readonly _entity: WallBlockEntity;
  // map
  private readonly _resolvers: { [key in CollideId]?: CollideHandler } = {
    goal: this._resolveGoal,
  };

  constructor(scene: GameScene, entity: WallBlockEntity) {
    this._scene = scene;
    this._entity = entity;
  }

  public async resolve(event: CollideEvent): Promise<boolean> {
    return this._resolvers[event.id]?.call(this, event) ?? false;
  }

  // private: resolvers
  //-------------------------------------------------------------------------
  private async _resolveGoal() {
    const component = this._entity.c.blockWall;
    const view = component.view;

    // Already broken.
    if (component.counter <= 0) {
      return false;
    }

    this._scene?.events.publish({ id: 'poke' });

    // Decrement counter.
    component.counter--;
    view.playHit();

    // If counter is 0.
    if (component.counter <= 0) {
      // Play lightning strike animation
      await view.playStrike();

      // despawn entity
      despawnBlockEntity(this._scene, this._entity);
    }

    return true;
  }
}
